import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";
import { Creators as AllCreators } from "../../actions";
import { IOrganization } from "../../reducers/course-author/types";
import { accountName, isAdminUser, organizationName as orgName } from "../../selectors/selectors";
import { IState } from "../reducer";
import { SelectOrganizationComponent } from "./SelectOrganization.component";
import { ISelectOrganizationStateProps } from "./types";

const Creators = (AllCreators as any).App.SelectOrganization;

const mapStateToProps = (state: IState): ISelectOrganizationStateProps => ({
  authenticationState: state.App._.authenticationState,
  fetchAllOrganizationsRequestError: state.App.SelectOrganization._.fetchAllOrganizationsRequestError,
  fetchAllOrganizationsRequestState: state.App.SelectOrganization._.fetchAllOrganizationsRequestState,
  isAdmin: isAdminUser(state),
  organizationName: orgName(state),
  organizations: state.App.SelectOrganization._.organizations || [],
  selectedOrganization: state.App._.organization,
  userName: accountName(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IAction>) => ({
  mount: () => {
    dispatch(Creators.mount());
    dispatch(Creators.fetchAllOrganizations());
  },
  selectOrganization: (org: IOrganization) => dispatch(Creators.selectOrganization(org)),
  unmount: () => dispatch(Creators.unmount()),
});

export const SelectOrganization = connect(mapStateToProps, mapDispatchToProps)(SelectOrganizationComponent);
